import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Spin } from "antd";
import authService from "../services/authService";
import { validateRedirectUrl } from "../utils/redirectValidator";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || isLoading) return;

    const redirect = async () => {
      setIsRedirecting(true);

      const params = new URLSearchParams(location.search);
      const defaultRedirect = "https://universe-uat.tvs.in/universe";
      const redirectUrl = validateRedirectUrl(params.get("redirectUrl"), defaultRedirect);

      const token = await authService.generateHandoffToken();
      const separator = redirectUrl.includes("?") ? "&" : "?";
      window.location.href = token
        ? `${redirectUrl}${separator}handoffToken=${token}`
        : redirectUrl;
    };

    redirect();
  }, [isAuthenticated, isLoading, location.search]);

  if (isLoading || isRedirecting) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  return <>{children}</>;
};

export default PublicRoute;
